import React, { useState, useContext, useEffect } from "react";
import { Link } from "react-router-dom";
import { ThemeContext } from "../../../contexts/theme";
import { useAuth } from "../../../services/useAuth";
import UserDropdown from "../UserDropdown";
import { HiMenuAlt1 } from "react-icons/hi";
import NotificationBell from "../NotificationBell";
import TopNavigation from "./TopNavigation";
import logoLight from "../../../assets/logos/logo-1.png";
import logoDark from "../../../assets/logos/logo-2.png";
import styles from "./AppHeader.module.scss";

const AppHeader = ({ toggleMenuMobile, useBorderBottom }) => {
  // One bell only — desktop stays mounted when display:none and would double WS/toasts.
  const [isMobileHeader, setIsMobileHeader] = useState(
    () =>
      typeof window !== "undefined" &&
      window.matchMedia("(max-width: 1199.88px)").matches,
  );
  const { theme } = useContext(ThemeContext);
  const { user: authUser } = useAuth();

  useEffect(() => {
    const mq = window.matchMedia("(max-width: 1199.88px)");
    const onChange = (e) => setIsMobileHeader(e.matches);
    setIsMobileHeader(mq.matches);
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, []);

  const handleClickMenuMobile = () => {
    toggleMenuMobile();
  };

  return (
    <>
      <div
        className={`${styles["header-container"]} ${
          useBorderBottom && styles["header-container--border-bottom"]
        }`}
      >
        {/* Desktop Header */}
        <div className={styles["header-container__desktop"]}>
          <div className={styles["header-brand-navigation"]}>
            <Link to="/" className={styles["header-logo"]} aria-label="Ana sayfa">
              <img
                src={theme === "dark" ? logoDark : logoLight}
                alt="Rovion"
              />
            </Link>
            <TopNavigation user={authUser} />
          </div>

          <div className="d-flex align-items-center justify-content-end">
            <div className={styles["header-container__desktop--options"]}>
              {!isMobileHeader && <NotificationBell />}
              <UserDropdown />
            </div>
          </div>
        </div>

        {/* Mobile Header */}
        <div className={styles["header-container__mobile"]}>
          <div className="d-flex align-items-center justify-content-between">
            <div className={styles["mobile-brand"]}>
              <HiMenuAlt1
                className={styles["header-container__mobile--icon"]}
                onClick={handleClickMenuMobile}
              />
              <Link to="/" aria-label="Ana sayfa">
                <img
                  src={theme === "dark" ? logoDark : logoLight}
                  alt="Rovion"
                />
              </Link>
            </div>
            <div className={styles["header-mobile"]}>
              <div className={styles["header-mobile__items"]}>
                {isMobileHeader && <NotificationBell />}
                <UserDropdown
                  hideName={true}
                  size="2rem"
                  className="border-0"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <SearchWrapper isOpen={modalOpen} onClose={() => setModalOpen(false)} /> */}
    </>
  );
};

export default AppHeader;
